// @flow
import * as React from 'react';

import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';

import styles from './ProductDetailsPrice.module.scss';;


type Props = {
  value?: number | string,
  children?: React.Node,
}

const ProductDetailsPrice = ({ children, value }: Props) => {
  const priceString = React.useMemo(() => toFixedValueCurrency(value, true), [value]);
  return (
    <div className={styles.root}>
      {children || priceString || ''}
    </div>
  );
};

export default ProductDetailsPrice;
